module.exports = __webpack_public_path__ + "infocentrum5.jpg?40caf96e2212c10387cec24b852b647f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/infocentrum/infocentrum5.jpg
// module id = 257
// module chunks = 0